import React from "react";
import moment from "moment";
const ModalContext = React.createContext();
const { Provider, Consumer } = ModalContext;

// TODO: Document it
class ModalContextProvider extends React.Component {

  constructor(props) {
    super(props);

    this.showModal     = this.showModal.bind(this);
    this.onModalShowed = this.onModalShowed.bind(this);
    this.hideModal     = this.hideModal.bind(this);
    this.onModalHidden = this.onModalHidden.bind(this);

    this.state = {};
  }

  showModal(type, modalInfo) {
    let key = modalInfo.key || moment().unix();
    this.setState({
      type: type,
      modalInfo: {
        ...modalInfo,
        key: key
      },
      modalShowed: true
    })
  }

  onModalShowed() {

  }

  hideModal() {
    this.setState({
      modalShowed: false
    })
  }

  onModalHidden() {
    this.setState({
      type: undefined,
      modalInfo: undefined,
      modalShowed: false
    })
  }

  render() {
    const { children } = this.props;

    const { type, modalInfo, modalShowed } = this.state;

    return <Provider value = { {
        type: type,
        modalInfo: modalInfo,
        modalShowed: modalShowed,
        showModal: this.showModal,
        onModalShowed: this.onModalShowed,
        hideModal: this.hideModal,
        onModalHidden: this.onModalHidden
      } } >
      { children }
    </Provider>
  }
}

export { ModalContext, ModalContextProvider, Consumer as ModalContextConsumer };

